export const messages = {
  en: {
    doAllocationOrderIn: {
      title: 'Confirm Storage',
      productInfo: 'Product Information',
      orderCode: 'Order Code',
      applicant: 'Applicant',
      applyTime: 'Apply Time',
      orderStatus: 'Order Status',
      sourceShop: 'Source Shop',
      sourceWarehouse: 'Source Warehouse',
      targetShop: 'Target Shop',
      targetWarehouse: 'Target Warehouse',
      reviewRemark: 'Review Remark',
      productCode: 'Product Code',
      productName: 'Product Name',
      specification: 'Specification',
      applyQuantity: 'Apply Quantity',
      actualQuantity: 'Actual Quantity',
      amount: 'Amount',
      confirmStorage: 'Confirm Storage',
      cancelOrder: 'Cancel Order',
      back: 'Back'
    }
  },
  zh: {
    doAllocationOrderIn: {
      title: '确定入库',
      productInfo: '商品信息',
      orderCode: '工单编码',
      applicant: '申请人',
      applyTime: '申请时间',
      orderStatus: '订单状态',
      sourceShop: '源商铺',
      sourceWarehouse: '源仓库',
      targetShop: '目标商铺',
      targetWarehouse: '目标仓库',
      reviewRemark: '审核备注',
      productCode: '商品编号',
      productName: '商品名称',
      specification: '规格',
      applyQuantity: '申请单数量',
      actualQuantity: '实际数量',
      amount: '金额',
      confirmStorage: '确定入库',
      cancelOrder: '取消入库单',
      back: '返回'
    }
  }
}